import { useEffect, useState } from "react";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("igreen_cookies")) setVisible(true);
  }, []);
  const choose = (v) => {
    localStorage.setItem("igreen_cookies", v);
    setVisible(false);
  };
  if (!visible) return null;
  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-5 left-5 right-5 sm:right-auto sm:max-w-md z-50 rounded-2xl border border-white/12 bg-[#0B261E]/95 backdrop-blur-xl p-5 shadow-2xl"
    >
      <p className="text-sm text-emerald-100/75 leading-relaxed">
        Usamos cookies para medir o site e mostrar anúncios para quem já nos visitou. Você escolhe.
      </p>
      <div className="mt-4 flex gap-3">
        <button
          data-testid="cookie-reject-button"
          onClick={() => choose("rejected")}
          className="flex-1 rounded-full border border-white/20 text-sm font-semibold text-emerald-100/70 px-4 py-2.5 hover:bg-white/5 transition-colors duration-300"
        >
          Recusar
        </button>
        <button
          data-testid="cookie-accept-button"
          onClick={() => choose("accepted")}
          className="flex-1 rounded-full bg-[#00E676] hover:bg-[#00C853] text-sm font-bold text-[#04120E] px-4 py-2.5 transition-colors duration-300"
        >
          Aceitar
        </button>
      </div>
    </div>
  );
};
